import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent } from '@personal-area/global/ui'
import { CardWrapperModule } from '@personal-area/global/ui';
import { IconSpriteModule } from '@personal-area/icon-sprite';

@Component({
  templateUrl: './us-identity-rejected.component.html',
  styleUrls: ['./us-identity-rejected.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonComponent,
    CommonModule,
    TranslateModule,
    RouterModule,
    CardWrapperModule,
    IconSpriteModule,
  ],
})
export class USIdentityRejectedComponent {

}
